// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a10a3f92e9--wrapper--tnKaw","title":"a10a3f92e9--title--EX4Zu","proofs":"a10a3f92e9--proofs--vXyks"};